import { ContextMenuWrapper } from "components/ContextMenu/ContextMenu";
import RecordLabel from "components/RecordLabel";
import bundleConfig from "config/resources/bundle";
import projectConfig from "config/resources/project";
import { Record, Resource } from "graphql/generated/graphql";
import { getRelativeUrl, getWorkspaceUrl } from "utils/service";
import { getRecordColumnCellStyle } from "components/Table/recordColumnWidths";

export const getLocationData = (data: Record) => {
    return data?.project_id_project ?? data?.bundle_id_bundle ?? data?.workspace_id_workspace;
};

export const locationColumn = (setNewValue?: any) => ({
    label: "Location",
    key: "location",
    dto: (props: Resource) => {
        const { project_id_project, bundle_id_bundle, workspace_id_workspace } = props;

        const getRecordLocation = () => {
            if (project_id_project) {
                return project_id_project;
            } else if (bundle_id_bundle) {
                return bundle_id_bundle;
            } else {
                return null;
            }
        };
        const location = getRecordLocation();

        if (location) {
            const resourceName = project_id_project
                ? projectConfig.resourceName
                : bundleConfig.resourceName;
            const children = (
                <RecordLabel
                    link={getRelativeUrl(resourceName, location.id)}
                    name={location.name}
                    image={location.icon}
                    iconByType={resourceName}
                />
            );
            const field =
                resourceName === projectConfig.resourceName
                    ? "project_id--project.id:name"
                    : "bundle_id--bundle.id:name";

            return setNewValue ? (
                <ContextMenuWrapper
                    handleClick={() =>
                        setNewValue({
                            field,
                            value: location.name,
                        })
                    }
                >
                    {children}
                </ContextMenuWrapper>
            ) : (
                children
            );
        } else {
            if (workspace_id_workspace) {
                const children = (
                    <RecordLabel
                        link={getWorkspaceUrl()}
                        name={workspace_id_workspace.name}
                        image={workspace_id_workspace.icon}
                        iconByType={"workspace"}
                    />
                );
                return setNewValue ? (
                    <ContextMenuWrapper
                        handleClick={() =>
                            setNewValue({
                                field: "workspace_id--workspace.id:name",
                                value: workspace_id_workspace.name,
                            })
                        }
                    >
                        {children}
                    </ContextMenuWrapper>
                ) : (
                    children
                );
            }
            return null;
        }
    },
    shown: true,
    sortable: false,
    cellStyle: getRecordColumnCellStyle("location"),
});
